import {
  Component,
  EventEmitter,
  HostListener,
  OnDestroy,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, Subject, takeUntil } from 'rxjs';
import { IDashboardState } from 'src/app/state-management/states/aumye-dashboard.state';
import { IAumyeState } from 'src/app/state-management/states/aumye.state';
import * as fromDashboardActions from 'src/app/state-management/actions/dashboard.action';
import { v4 as uuidv4 } from 'uuid';
import { Visitor } from 'src/app/models/visitor';
import { AumyeResponsiveScreenService } from 'src/app/services/screenResize/aumye-responsive-screen.service';
import { ScreenType } from 'src/app/enums/ScreenType';
import { IIncidents } from 'src/app/models/incident';
import { ComplaintsTickets } from 'src/app/models/tickets';
import { MatDialog } from '@angular/material/dialog';
import { ManageVisitorPassDialogComponent } from 'src/app/common/modules/dialog-pop-ups/components/manage-visitor-pass-dialog/manage-visitor-pass-dialog.component';
import { AumyeEmergencyLocationService } from 'src/app/services/aumye-emergency-location.service';
import { environment } from 'src/app/environments/environments';
import {
  EncryptionService,
  UserDetailsToken,
} from 'src/app/services/Encryption/encryption.service';
import { Capacitor } from '@capacitor/core';

@Component({
  selector: 'app-dashboard-container',
  templateUrl: './dashboard-container.component.html',
  styleUrls: ['./dashboard-container.component.scss'],
})
export class DashboardContainerComponent implements OnInit {
  destroyed$: Subject<any> = new Subject<any>();
  dashboardState$: Observable<IDashboardState>;
  dashboardData: IDashboardState;
  visitList: Visitor[] = [];
  isUser = false;
  screenSize: ScreenType;
  deviceWidth: number = window.innerWidth;
  role: string = null;
  orgId: string = null;
  incidentDetails: IIncidents;
  isShowServiceDetails = false;
  showNoticeBoard = false;
  matIndex = 0;
  @ViewChild('RequestDialog', { static: true })
  requestDialog: TemplateRef<any>;
  disabledOrgIds: string[] = [];
  isDisableFeature: boolean = false;
  loggedUser: UserDetailsToken;

  @Output() isDashboardFlow = new EventEmitter<any>();
  isNative: boolean = true;

  constructor(
    private store: Store<IAumyeState>,
    private _screenSize: AumyeResponsiveScreenService,
    private dialog: MatDialog,
    private encryptionService: EncryptionService,
    private aumyeEmergencyLocationService: AumyeEmergencyLocationService
  ) {
    this.loggedUser = this.encryptionService.getCurrentUser();
    this.isUser = this.loggedUser.role == 'user';
    this.role = this.loggedUser.role;
    this.orgId = this.loggedUser.organizationID;
    this.dashboardState$ = this.store.select('aumyeDashboardState');
    this.dashboardState$.pipe(takeUntil(this.destroyed$)).subscribe((data) => {
      this.dashboardData = data;
      if (this.incidentDetails) {
        const filterData = this.isComplaint
          ? this.dashboardData.complaintsTickets
          : this.isClaim
          ? this.dashboardData.claimTickets
          : this.dashboardData.requestsTickets;
        if (filterData) {
          let newincidentDetailsData = filterData.find(
            (x) => x.complainId == this.incidentDetails.incidentId.toLowerCase()
          )?.complainIncidentDetails;
          if (!newincidentDetailsData) {
            newincidentDetailsData =
              this.dashboardData.incidentDetails.incidentList.find(
                (x) => x.incidentId == this.incidentDetails.incidentId
              );
          }
          this.incidentDetails = newincidentDetailsData;
        }
      }
    });
    this.deviceWidth = window.innerWidth;
    // if (this.role === 'housekeeping') {
    //   this.matIndex = 2;
    // }
    if (this.role === 'device')
      this.store.dispatch(new fromDashboardActions.InitEmplopyee({}));
  }
  ngOnInit(): void {
    // if (this.role === 'housekeeping') {
    //   this.matIndex = 2;
    // } else
    this.isNative = Capacitor.isNativePlatform();
    this.disabledOrgIds = environment.printerAllowed;
    this.isDisableFeature = this.disabledOrgIds
      .map((id) => id.toLowerCase())
      .includes(this.orgId?.toLowerCase());

    this.matIndex = 0;
    this.updateVisitorData();

    this._screenSize.getScreenType().subscribe((screenData) => {
      this.screenSize = screenData;
      if (screenData == ScreenType.Mobile) {
        const deviceWidth = window.innerWidth + 'px';
        document.documentElement.style.setProperty(
          '--device-width',
          deviceWidth
        );
        const tabFontSize = 12 + 'px';
        document.documentElement.style.setProperty(
          '--font-size-tab',
          tabFontSize
        );
      } else if (screenData == ScreenType.Tablet) {
        const deviceWidth = 1020 + 'px';
        document.documentElement.style.setProperty(
          '--device-width',
          deviceWidth
        );
      } else if (screenData == ScreenType.Desktop) {
        const deviceWidth = 1440 + 'px';
        document.documentElement.style.setProperty(
          '--device-width',
          deviceWidth
        );
      }
    });
  }
  onClickedAdvancedSos() {
    this.store.dispatch(new fromDashboardActions.InitSecurityAdvanced({}));
  }
  updateVisitorData() {
    setInterval(() => {
      this.dashboardData.visitorDetails.visitorList.forEach((x) => {
        if (
          x.isGateEntry == '1' &&
          x.securityStatus == 0 &&
          x.isPreApproved != 'true' &&
          new Date().getDate() == new Date(x.visitDateTime).getDate()
        ) {
          this.visitList.push(x);
        }
      });

      if (this.visitList.length > 0) {
        // this.store.dispatch(new fromDashboardActions.UpdateVisitorList({}));
        this.visitList = [];
      }
    }, 3000000);
  }
  clickedScheduleVisitor(val: any) {
    this.store.dispatch(new fromDashboardActions.RapidScheduleVisitor(val));
  }
  clickedLodgeComplaint(val: any) {
    this.store.dispatch(new fromDashboardActions.LodgeUserComplain(val));
  }
  clickedSendBulkInvite(val: any) {
    this.store.dispatch(new fromDashboardActions.SendBulkInvite(val));
  }
  clickedCreateUserPost(val: any) {
    this.store.dispatch(new fromDashboardActions.CreateNoticeBoardPost(val));
  }
  onClickedScanQR() {
    this.store.dispatch(new fromDashboardActions.InitSecurityGuardTab({}));
  }
  clickedRefreshUserPost() {
    this.store.dispatch(new fromDashboardActions.GetNoticeBoardPosts({}));
  }
  clickedPostUserComment(val: any) {
    this.store.dispatch(new fromDashboardActions.PostUserComment(val));
  }
  clickedPostUserLike(val: any) {
    this.store.dispatch(new fromDashboardActions.PostUserLike(val));
  }
  clickedPreApprovedVisitor(val: any) {
    this.store.dispatch(new fromDashboardActions.AddPreApprovedVisitor(val));
  }
  clickedSaveUserReportPost(val: any) {
    this.store.dispatch(new fromDashboardActions.ReportCommunityPost(val));
  }
  clickedCreateUserPoll(val: any) {
    this.store.dispatch(new fromDashboardActions.CreateUserPoll(val));
  }
  submitPollResponse(val: any) {
    this.store.dispatch(new fromDashboardActions.SubmitPollResponse(val));
  }
  removePreApprovedVisitor(val: any) {
    this.store.dispatch(new fromDashboardActions.UpdateVisitorDetails(val));
  }
  visitorCheckout(val: any) {
    this.store.dispatch(
      new fromDashboardActions.PreApprovedVisitorCheckout(val)
    );
  }
  createManualEvent() {
    this.store.dispatch(new fromDashboardActions.InitIncidentManualEvent({}));
  }
  addGateEntry() {
    this.store.dispatch(new fromDashboardActions.InitVisitorGateEntry({}));
  }
  securityCallback(val: any) {
    this.store.dispatch(new fromDashboardActions.CreateManualIncident(val));
  }
  submitUserRequest() {
    this.store.dispatch(new fromDashboardActions.InitDashboard({}));
  }
  userComplain: ComplaintsTickets;
  isComplaint = false;
  isClaim = false;
  isRequest = false;
  onShowServiceDetails(val: ComplaintsTickets) {
    if (this.role === 'housekeeping') {
      if (this.matIndex == 0) {
        this.isComplaint = true;
        this.isClaim = false;
        this.isRequest = false;
      } else if (this.matIndex == 1) {
        this.isClaim = true;
        this.isComplaint = false;
        this.isRequest = false;
      } else {
        this.isRequest = true;
        this.isClaim = false;
        this.isComplaint = false;
      }
    } else {
      if (this.matIndex == 2) {
        this.isComplaint = true;
        this.isClaim = false;
        this.isRequest = false;
      } else if (this.matIndex == 3) {
        this.isClaim = true;
        this.isComplaint = false;
        this.isRequest = false;
      } else {
        this.isRequest = true;
        this.isClaim = false;
        this.isComplaint = false;
      }
    }

    this.incidentDetails = val.complainIncidentDetails;
    this.userComplain = val;
    this.isShowServiceDetails = true;
  }
  onCloseIncidentDetail() {
    this.isShowServiceDetails = false;
  }
  onVerifyIncident(val: any) {
    this.store.dispatch(new fromDashboardActions.VerifyIncident(val));
  }
  onUpdateRequests(val: any) {
    let previousDetails = this.dashboardData.incidentDetails.incidentList.find(
      (x) => x.incidentId == val.incidentId
    );
    if (!previousDetails) {
      previousDetails = this.dashboardData.complaintsTickets.find(
        (x) => x.complainId == val.incidentId.toLowerCase()
      )?.complainIncidentDetails;
      if (!previousDetails) {
        previousDetails = this.dashboardData.requestsTickets.find(
          (x) => x.complainId == val.incidentId.toLowerCase()
        )?.complainIncidentDetails;
        if (!previousDetails) {
          previousDetails = this.dashboardData.claimTickets.find(
            (x) => x.complainId == val.incidentId.toLowerCase()
          ).complainIncidentDetails;
        }
      }
    }
    val['previousStatus'] = previousDetails.incidentStatus;
    val['previousAssigned'] = previousDetails.assignedTo;
    val['previousIncidentName'] = previousDetails.incidentName;
    val['previousCreatedBy'] = previousDetails.eventCreatedBy;
    val['previousIncidentType'] = previousDetails.incidentType;
    val['previousSourceAsset'] = previousDetails.sourceAsset;
    val['previousIncidentLocation'] = previousDetails.incidentLocation;
    val['previousIncidentDescription'] = previousDetails.incidentDescription;
    val['previousIncidentCriticality'] = previousDetails.incidentCriticality;
    this.onSnoozeIncident(val);
  }
  onIsPreverifiedFlow(val: any) {
    this.store.dispatch(new fromDashboardActions.InitPreVerified({}));
  }
  onIsAumyeCommunity(val: any) {
    this.store.dispatch(new fromDashboardActions.InitAumyeCommunity({}));
  }
  onSnoozeIncident(val: any) {
    this.store.dispatch(new fromDashboardActions.SnoozeIncident(val));
  }
  onPostIncidentComment(val: any) {
    this.store.dispatch(new fromDashboardActions.PostUserComment(val));
  }
  onUpdateVisitorDetails(val: Visitor) {
    this.store.dispatch(new fromDashboardActions.UpdateVisitorDetails(val));
  }
  sendReports(val: any) {
    this.store.dispatch(new fromDashboardActions.SendReportsData(val));
  }
  onMarkAsArrivedVisitor(val: any) {
    this.store.dispatch(new fromDashboardActions.VisitorNotifyHost(val));
  }
  searchNumber(val: any) {
    this.store.dispatch(new fromDashboardActions.SearchNumber(val));
  }
  getInventoryList() {
    this.store.dispatch(new fromDashboardActions.GetUserInventory({}));
  }
  onChangeTab(val: any) {
    this.matIndex = val.index;
    this.isShowServiceDetails = false;
  }
  onMarkMultipleApproved(val: any) {
    this.store.dispatch(
      new fromDashboardActions.ClusterPreApprovedVisitor(val)
    );
  }
  onOpenManageVisitorDialog() {
    const preApprovedVisitorList =
      this.dashboardData.visitorDetails.visitorList.filter(
        (visitor) => visitor.securityStatus == 1
      );
    const dialogRef = this.dialog.open(ManageVisitorPassDialogComponent, {
      disableClose: true,
      data: { visitor: preApprovedVisitorList, screen: this.screenSize },
    });
    dialogRef.componentInstance.onReNewVisitorPass.subscribe((data: any) => {
      this.store.dispatch(new fromDashboardActions.ManageVisitorPass(data));
    });
    dialogRef.componentInstance.onSuspendVisitorPass.subscribe((data: any) => {
      this.store.dispatch(new fromDashboardActions.ManageVisitorPass(data));
    });
  }
  clickedSaveUserInventory(val: any) {
    this.store.dispatch(new fromDashboardActions.SaveUserInventory(val));
  }
  onRaiseRequest() {
    this.dialog.open(this.requestDialog, {
      disableClose: false,
    });
    const requestId = uuidv4();
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const requestSosData = {
            currentLocation: position.coords,
            requestId: requestId,
          };
          this.requestSOS(requestSosData);
          this.aumyeEmergencyLocationService.addNewRequestToFirebase(
            requestSosData
          );
        },
        (error) => {
          window.alert(error);
        }
      );
    } else {
      window.alert('Geolocation is not supported by this browser');
    }
  }
  requestSOS(val: any) {
    this.store.dispatch(new fromDashboardActions.RequestSOS(val));
  }
  onLogAttendance(val: any) {
    this.store.dispatch(new fromDashboardActions.LogEmployeeAttendance(val));
  }
  onClusterPreApprovedVisitor(val: any) {}
  onGetRangeData(val: any) {
    this.store.dispatch(new fromDashboardActions.GetRangedRequestsData(val));
  }
  onGetRequestData() {
    this.store.dispatch(new fromDashboardActions.GetComplaintsTickets({}));
    this.store.dispatch(new fromDashboardActions.GetClaimTickets({}));
    this.store.dispatch(new fromDashboardActions.GetRequestsTickets({}));
  }
  onGetUpdatedRequestData(val: any) {
    this.store.dispatch(new fromDashboardActions.GetRequestsTickets({}));
  }
  acceptOrRejectPost(val: any) {
    this.store.dispatch(new fromDashboardActions.AcceptOrRejectPost(val));
  }
  onPostFlaggedpostAction(val: any) {
    this.store.dispatch(new fromDashboardActions.UpdateFlaggedPost(val));
  }
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.deviceWidth = window.innerWidth;
    // Set the SCSS variable value to match the updated deviceWidth
    document.documentElement.style.setProperty(
      '--device-width',
      this.deviceWidth + 'px'
    );
  }
  ScreenType = ScreenType;
}
